module.exports = "/images/user.svg?c0716061c041481fca6f0236cf90fe4b";